import React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Form, Select, Tooltip } from '../../../../../components';
import { getVSphereVersionsList } from '../../../../../lib/helpers';

const versionOptions = getVSphereVersionsList().map((v) => ({
    label: v.label,
    value: v.version,
}));

export const VSphereVersionField = ({ value, onChange, disabled = false, error }) => {
    return (
        <Form.Item
            label={
                <span>
                    vSphere Version{' '}
                    <Tooltip title="Provide a version for your destination cloud.">
                        <QuestionCircleOutlined />
                    </Tooltip>
                </span>
            }
            validateStatus={error ? 'error' : ''}
            help={error}
        >
            <Select
                value={value}
                options={versionOptions}
                onChange={onChange}
                disabled={disabled}
                placeholder="Select vSphere version"
            />
        </Form.Item>
    );
};
